var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 0.75C15.1454 0.75 14.25 1.64543 14.25 2.75C14.25 3.85457 15.1454 4.75 16.25 4.75H23.75C24.8546 4.75 25.75 3.85457 25.75 2.75C25.75 1.64543 24.8546 0.75 23.75 0.75H16.25ZM1.75 8.75C1.75 7.64543 2.64543 6.75 3.75 6.75H8.75H31.25H36.25C37.3546 6.75 38.25 7.64543 38.25 8.75C38.25 9.85457 37.3546 10.75 36.25 10.75H33.25V36.25C33.25 37.3546 32.3546 38.25 31.25 38.25H8.75C7.64543 38.25 6.75 37.3546 6.75 36.25V10.75H3.75C2.64543 10.75 1.75 9.85457 1.75 8.75ZM10.75 10.75H29.25V34.25H10.75V10.75ZM16.25 13C17.3546 13 18.25 13.8954 18.25 15V27.5C18.25 28.6046 17.3546 29.5 16.25 29.5C15.1454 29.5 14.25 28.6046 14.25 27.5V15C14.25 13.8954 15.1454 13 16.25 13ZM25.75 15C25.75 13.8954 24.8546 13 23.75 13C22.6454 13 21.75 13.8954 21.75 15V27.5C21.75 28.6046 22.6454 29.5 23.75 29.5C24.8546 29.5 25.75 28.6046 25.75 27.5V15Z",
    fill: "#F42E33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRedIcon);
export default __webpack_public_path__ + "static/media/trashRedIcon.401a0c02355e49283fbd71356e504b10.svg";
export { ForwardRef as ReactComponent };